<template>
  <span class="date-time">
    {{dateTime || '∞'}}
  </span>
</template>

<script>
export default {
  name: 'validity',
  props: {
    value: {
      type: String,
    },
  },
  computed: {
    dateTime() {
      if (!this.value) return null;
      const dateTime = new Date(this.value);
      return this.$d(dateTime, 'long');
    },
  },
};
</script>



// WEBPACK FOOTER //
// Validity.vue?1a9e15a0